import { motion } from "framer-motion";
import { CTA } from "@/components/kit";
import { PassportStamp } from "@/components/PassportStamp";
import { useLang } from "@/i18n/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section className="relative flex min-h-[75vh] items-center justify-center overflow-hidden px-5 py-24 text-center">
      <div className="pointer-events-none absolute -left-24 top-10 h-80 w-80 rounded-full bg-mint/40 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-sky/30 blur-3xl" />

      <div className="relative">
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mx-auto mb-8 w-fit"
        >
          <PassportStamp code="404" label="LOST" color="#FF8A80" rotate={-10} size={132} />
        </motion.div>

        <motion.h1
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="font-display text-4xl sm:text-6xl font-extrabold tracking-tighter text-ink"
        >
          {t("notfound.title")}
        </motion.h1>

        <motion.p
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.28, duration: 0.6 }}
          className="mx-auto mt-5 max-w-md text-lg text-ink/70 leading-relaxed"
        >
          {t("notfound.text")}
        </motion.p>

        <motion.div
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mt-9 flex justify-center"
        >
          <CTA to="/" variant="coral" data-testid="notfound-home-cta">
            {t("notfound.cta")}
          </CTA>
        </motion.div>
      </div>
    </section>
  );
}
